export default __webpack_public_path__ + "static/media/BosaImportants4.cb778ca0.JPG";